import { frontendURL } from '../../../helper/URLHelper';

const FlowsV2ListView = () => import('./FlowsV2ListView.vue');
const FlowBuilderView = () => import('./FlowBuilderView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/flujos-v2'),
      name: 'flows_v2_list',
      component: FlowsV2ListView,
      meta: { permissions: ['administrator', 'module_flows'] },
    },
    {
      path: frontendURL('accounts/:accountId/flujos-v2/:flowId'),
      name: 'flows_v2_builder',
      component: FlowBuilderView,
      meta: { permissions: ['administrator', 'module_flows'] },
    },
  ],
};
